import { NgModule } from '@angular/core';
import { ViewFileComponent } from './view-file.component';

@NgModule({
  declarations: [ViewFileComponent],
  exports: [ViewFileComponent]
})
export class ViewFileModule {}
